import React, { useEffect, useState } from "react";
import { createTheme, TextField } from "@mui/material";
import { colors } from "../../common/pallette/colors";
import { ThemeProvider } from "@emotion/react";

const TextAreaOrderedList = (props:any) => {
  const { placeholder, manageOnBlur, rows, handleChange, value } = props;
  const [valueStatic, setValue] = useState(value);
  const theme = createTheme({
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            backgroundColor: colors.grey.bright,
            "&.Mui-focused": {
              backgroundColor: colors.grey.bright,
            },
            padding: 0,
          },
          input: {
            padding: "6px",
            fontSize: "12px",
          },
        },
      },
    },
  });

  const handleChangeInternal = (event: any) => {
    const newValue = event.target.value;
    setValue(newValue);
    handleChange(newValue);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default new line behavior

      const lines = valueStatic.split("\n");
      const nextNumber = lines.length + 1; // Determine next number
      const newValue = valueStatic + `\n${nextNumber}. `; // Append new line with number

      setValue(newValue);
      handleChange(newValue);
    }
  };
  const handleClick = () => {
    if (!valueStatic.trim()) {
      setValue("1. "); // Start numbering if empty
    }
  };

  useEffect(() => {
    value != null && setValue(value);
  }, [value])

  return (
    <ThemeProvider theme={theme}>
      <TextField
        sx={{
          // Enable resize functionality
          '& .MuiInputBase-root': {
            resize: 'vertical', // Allows vertical resizing only
          },
          '& textarea': {
            resize: 'vertical', // Targets the textarea element directly
            '&::-webkit-resizer': {
            border: '20px solid transparent', // Increase from default ~4px
            borderRight: '20px solid #999', // Color and size of the handle
            borderBottom: '20px solid #999',
          }
          }
        }}
        rows={rows ? rows : 4}
        multiline
        fullWidth
        value={valueStatic}
        onClick={handleClick}
        onChange={handleChangeInternal}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        variant="outlined"
        onBlur={manageOnBlur}
      />
    </ThemeProvider>
  );
};

export default TextAreaOrderedList;
